import { useState, useEffect } from "react";
import {
  bar_brands,
  bar_weights,
  coin_weights,
  pc_brands,
  silverbar_brands,
  silverbar_weights,
} from "../../utils/constant";

export default function DescriptionModal({
  show,
  onClose,
  onSave,
  initialValue,
}) {
  const [product, setProduct] = useState("");
  const [brand, setBrand] = useState("");
  const [weight, setWeight] = useState("");

  const [brands, setBrands] = useState([]);
  const [weights, setWeights] = useState([]);

  // Initialize if editing existing value
  useEffect(() => {
    if (initialValue) {
      // optional: parse previous value if needed
    }
  }, [initialValue]);

  // Handle product change
  const handleProductChange = (value) => {
    setProduct(value);
    setBrand("");
    setWeight("");

    // Mock logic (replace with API later)
    if (value === "PC") {
      setBrands(pc_brands);
      setWeights([]);
    } else if (value === "BAR") {
      setBrands(bar_brands);
      setWeights(bar_weights);
    } else if (value === "SILVER_BAR") {
      setBrands(silverbar_brands);
      setWeights(silverbar_weights);
    } else if (value === "COIN") {
      setBrands([]);
      setWeights(coin_weights);
    } else {
      setBrands([]);
      setWeights([]);
    }
  };

  const handleSave = () => {
    const description = `${product} ${brand} ${weight}`.trim();
    onSave(description);
    onClose();
  };

  if (!show) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)",
          zIndex: 1040,
        }}
      />
      {/* Modal */}
      <div
        role="dialog"
        aria-labelledby="capitalLoginTitle"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          borderRadius: "16px",
          width: "min(540px, 95vw)",
          //   boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
        }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3>Select Description</h3>
            <button className="modal-close" onClick={onClose}>
              <i className="fa-solid fa-times"></i>
            </button>
          </div>

          <div className="modal-body">
            {/* Product Selection */}
            <div className="modal-field-row">
              <label className="modal-label">Select Product</label>
              <select
                className="modal-select"
                value={product}
                onChange={(e) => handleProductChange(e.target.value)}
              >
                <option value="">Select Product</option>
                <option value="PC">PC</option>
                <option value="COIN">COIN</option>
                <option value="BAR">BAR</option>
                <option value="SILVER_BAR">SILVER BAR</option>
              </select>
            </div>

            {/* Brand Field */}
            {brands.length > 0 && (
              <div className="modal-field-row">
                <label className="modal-label">Select Brand</label>
                <select
                  className="modal-select"
                  value={brand}
                  onChange={(e) => setBrand(e.target.value)}
                >
                  <option value="">Select Brand</option>
                  {brands.map((b, i) => (
                    <option key={i} value={b}>
                      {b}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Weight Field */}
            {weights.length > 0 && (
              <div className="modal-field-row">
                <label className="modal-label">Select Weight</label>
                <select
                  className="modal-select"
                  value={weight}
                  onChange={(e) => setWeight(e.target.value)}
                >
                  <option value="">Select Weight</option>
                  {weights.map((w, i) => (
                    <option key={i} value={w}>
                      {w}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* Actions */}
            <div className="modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
